import React from "react";
import { Modal, Box, Typography, IconButton, Button, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface CustomModalProps {
	open: boolean;
	handleClose: () => void;
	title: string;
	subtitle?: string;
	onSave: () => void;
	saveTitle?: string;
	children: React.ReactNode;
	width?: number;
	saveButtonName?: string;
	button2?: string;
	onClickButton2?: () => void;
	btnLoading?: boolean;
	isSaveButtonShow?: boolean;
	borderBottom?: string;
	draftButtonName?: string;
	onSaveDraft?: () => void;
	isDraftButtonShow?: boolean;
}

const CustomModal: React.FC<CustomModalProps> = ({
	open,
	handleClose,
	title,
	subtitle,
	children,
	onSave,
	saveTitle = "Save",
	width,
	saveButtonName,
	button2,
	onClickButton2,
	btnLoading,
	isSaveButtonShow = true,
	borderBottom,
	draftButtonName = "Save as Draft",
	onSaveDraft,
	isDraftButtonShow = false,
}) => {
	return (
		<Modal open={open} onClose={handleClose} sx={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}>
			<Box
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: {
						xs: "90%",
						sm: "80%",
						md: width ? width : 500,
					},
					maxHeight: "95vh",
					bgcolor: "#393939",
					boxShadow: 24,
					p: 1,
					color: "#ffffff",
					borderRadius: 0,
				}}>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "flex-start",
						px: 2,
						pt: 3,
						pb: subtitle ? 1.5 : 0,
					}}>
					{(title || subtitle) && (
						<Box sx={{ flex: 1, pr: 2 }}>
							{title && (
								<Typography variant="h6" sx={{ fontSize: "16px", fontWeight: "600", lineHeight: 1.3 }}>
									{title}
								</Typography>
							)}
							{subtitle && (
								<Typography
									sx={{
										fontSize: "12px",
										color: "#CCCCCC",
										mt: title ? 0.75 : 0,
										lineHeight: 1.4,
									}}>
									{subtitle}
								</Typography>
							)}
						</Box>
					)}
					{!title && !subtitle && <Box sx={{ flex: 1 }} />}
					<IconButton
						sx={{
							"&:hover": {
								backgroundColor: "transparent",
							},
						}}
						onClick={handleClose}>
						<CloseIcon
							sx={{
								color: "#E12013",
								position: "relative",
								top: -4,
								right: -3,
							}}
						/>
					</IconButton>
				</Box>
				<Box
					sx={{
						borderBottom: borderBottom || "1px solid #CCCCCC",
						marginX: "15px",
					}}></Box>
				<Box
					className="scrollbar"
					sx={{
						flexGrow: 1,
						overflowY: "auto",
						p: 2,
						maxHeight: "70vh",
					}}>
					<Box>{children}</Box>
					{isSaveButtonShow && (
						<Box sx={{ display: "flex", justifyContent: "center", mt: 3, mb: 3 }}>
							{isDraftButtonShow && (
								<Button
									fullWidth
									variant="contained"
									className="saveBtn"
									style={{
										borderRadius: "0px",
										background: "#393939",
										maxWidth: "140px",
										marginRight: "20px",
									}}
									onClick={onSaveDraft}>
									<Typography>{draftButtonName}</Typography>
								</Button>
							)}
							<Button
								fullWidth
								variant="contained"
								className="saveBtn"
								style={{
									background: "#393939",
									borderRadius: "0px",
									maxWidth: "140px",
									padding: "10px 0px",
								}}
								onClick={onSave}
								disabled={btnLoading}>
								{btnLoading ? (
									<>
										<CircularProgress size={18} sx={{ color: "white", padding: "0px 8px" }} />
										<Typography>Submitting..</Typography>
									</>
								) : (
									<Typography>{saveButtonName ? saveButtonName : saveTitle}</Typography>
								)}
							</Button>

							{button2 && (
								<Button
									fullWidth
									variant="contained"
									className="saveBtn"
									style={{
										borderRadius: "0px",
										background: "#393939",
										maxWidth: "140px",
										marginLeft: "20px",
									}}
									onClick={onClickButton2}>
									<Typography>{button2}</Typography>
								</Button>
							)}
						</Box>
					)}
				</Box>
			</Box>
		</Modal>
	);
};

export default CustomModal;
